





























import Vue from "vue";
import { Component } from "vue-property-decorator";
import store from "./store/store";
import Header from "./views/Head.vue";
import Nav from "./views/Nav.vue";
import Footer from "./views/Footer.vue";

// @Component({
//   components: {
//     'header-view': Header,
//     'nav-view': Nav,
//     'footer-view': Footer
//   },
// })
export default Vue.extend({
  name: "app",
  components: {
    "header-view": Header,
    "nav-view": Nav,
    "footer-view": Footer,
  },
  computed: {
    isHome() {
      const v: Vue = this;
      return v.$route.path === "/" ? true : false;
    },

    isTilmeline() {
      return this.$route.path == "/timeline" ? true : false;
    },
  },
});
